module.exports = __webpack_public_path__ + "assets/images/ride-clean-up@3x-2b39925ff3fe45b13630eb55d60cce95.png";